import React from 'react';

import { S3_BUCKET_URL } from '@/constants';
import { amplitudeModule } from '@/modules/amplitude';
import { canLogEvents } from '@/utils/canLogEvents.ts';

import { MediaScreen } from '../MediaScreen';

export const Video: React.FC = () => {
  React.useEffect(() => {
    if (canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'Photo',
      });
    }
  }, []);

  return (
    <MediaScreen
      title="And videos too..."
      videoSrc={`${S3_BUCKET_URL}/layout-own-ai-maxim/video/video.webm`}
      videoAlt="Video screen"
      buttonText="I need more"
      screenName="Video Screen"
    />
  );
};
